<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <h4 class="title ">Users</h4>
          <table class="table is-striped is-narrow ">
            <thead>
            <tr>
              <th>ID</th>
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users" :id="user.uid">
              <td>{{ user.uid }}</td>
              <td>{{ user.username }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.role }}</td>
              <td>
                <button class="button is-danger is-outlined" :style="'font-size:.8rem;'"
                        v-on:click="deleteUser(user.uid)"><i
                  class="fa fa-lg fa-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </article>

      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <form v-on:submit.prevent="adduser">
            <h1 class="title">Add User</h1>
            <div class="block">
              <label class="label">Email</label>
              <p class="control">
                <input v-model="data.body.email" class="input" type="email" placeholder="email">
              </p>
              <label class="label">Username</label>
              <p class="control has-icon has-icon-right">
                <input v-model="data.body.username" class="input" type="text" placeholder="username" value="username">
              </p>
              <label class="label">Password</label>
              <p class="control">
                <input v-model="data.body.password" class="input" type="password" placeholder="password">
              </p>
              <p class="control">
                <button class="button is-primary">Submit</button>
              </p>
            </div>
          </form>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        users: [],
        data: {
          body: {
            username: '',
            email: '',
            password: ''
          }
        }
      }
    },
    methods: {
      deleteUser (id) {
        this.$http({
          url: '/api/v1/user/delete/' + id
        }).then((response) => {
          if (response.status === 200 && response.data.success === true) {
            document.getElementById(id).remove()
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      adduser () {
        this.$http.post(
          '/api/v1/user/add',
          this.data.body
        ).then((response) => {
          if (response.data.success) {
            this.$http({
              url: '/api/v1/user/fetch/all'
            }).then((response) => {
              this.users = []
              this.users.push(...response.data)
            }).catch((error) => {
              console.log(error)
            })
          }
        })
      }
    },
    beforeCreate () {
      this.$http({
        url: '/api/v1/user/fetch/all'
      }).then((response) => {
        this.users = []
        this.users.push(...response.data)
      }).catch((error) => {
        console.log(error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// HandleUsers.vue?2e6c7be8